import { createContext } from 'react';

export interface PreRoute {
  getPreRoute: () => string | undefined;
  goBackOrHome: () => void;
  backRouter: (fallbackRoute?: string) => void;
}

export default createContext<PreRoute | undefined>(undefined);
